module.exports = __webpack_public_path__ + "assets/img/left_3.5b543f8a.png";